import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-three-bars",
  templateUrl: "./med-icon-three-bars.component.html",
})
export class MedIconThreeBarsComponent extends SvgMixinComponent {}
